import React, { useState, useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "../Login/Login.css";
import { useNavigate } from "react-router-dom";
import logo2 from "../../assets/logo.avif";
import UserDataContext from "../../Context/UserDataContext/UserDataContext";
import { getProfileData } from "../../utils/api";
import useLocalStorage from "../../hooks/useLocalStorage";
import TypewriterComponent from "typewriter-effect";
import { Button, message } from "antd";
import { ModalinputFormField, ModalinputNumberFormField } from "./Components";
import AntdModal from "../../Components/Modals/AntdModal";
import styles from "./Components.module.css";
import { fetchWrapper } from "../../utils/misc";
import { msgSuccess, msgError } from "../../utils/notification";
import { LoadingOutlined, UnlockOutlined } from "@ant-design/icons";
import { TiLockOpen, TiLockOpenOutline } from "react-icons/ti";
// import { initializeFCM,getBrowserName,getDeviceType } from "../Notification/InitilizeFCM";
// import { getBrowserName } from "../Notification/InitilizeFCM";

export default function Login() {
  const [UserId, setUserId] = useState("");
  const [password, setpassword] = useState("");
  const navigate = useNavigate();
  const [OfficialMail, setOfficialMail] = useState(null);
  const [loginErrorMssg, SetLoginErrorMssg] = useState("");
  const [loading, setLoading] = useState(false);
  const [activeModalId, setActiveModalId] = useState(false);
  const [jwtStoredValue, setJwtStoredValue] = useLocalStorage("JwtToken");
  const redirectFromMail = localStorage.getItem("redirectFromMail");
  const appraisalFormId = localStorage.getItem("appraisalFormId");
  const appraisalEmpId = localStorage.getItem("appraisalEmpId");
  const [messageApi, contextHolder] = message.useMessage();
  const [sendMailbutton, setSendmailbutton] = useState("Send Mail");
  const [upcomingFestivals, setUpcomingFestival] = useState();
  const [currentFestivalIndex, setCurrentFestivalIndex] = useState(0);

  const { setUserData } = useContext(UserDataContext);
  const userData = localStorage.getItem("userData");

  useEffect(() => {
    upcomingFestival();
  }, []);

  useEffect(() => {
    if (!upcomingFestivals || upcomingFestivals.length === 0) return;

    const interval = setInterval(() => {
      setCurrentFestivalIndex(
        (prevIndex) => (prevIndex + 1) % upcomingFestivals.length,
      );
    }, 3000);
    return () => clearInterval(interval);
  }, [upcomingFestivals]);

  async function handleSubmit(e) {
    e.preventDefault();
    LoginForm();
  }

  async function LoginForm() {
    let formData = {
      UserId: UserId,
      password: password,
    };

    setLoading(true);
    SetLoginErrorMssg("");

    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/Authentication/Login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        },
      );
      const loginData = await res.json();

      if (loginData.resCode === 200) {
        setJwtStoredValue(loginData.resData.token);
        localStorage.setItem("EmpId", loginData.resData.employeeId);
        const result = await getProfileData(
          setUserData,
          localStorage.getItem("JwtToken"),
          messageApi,
          msgError,
          loginData.resData.token,
        );
        if (!result) {
          return;
        }
        if (
          Boolean(redirectFromMail) === true &&
          !Number.isNaN(+appraisalFormId) &&
          !Number.isNaN(+appraisalEmpId) &&
          result &&
          result.loginId === +appraisalEmpId
        ) {
          localStorage.setItem("userImage", result.image);
          navigate(`/Appraisal/${appraisalFormId}?EmpId=${appraisalEmpId}`);
        } else {
          navigate("/Dashboard", { replace: true });
        }
      } else if (loginData.resCode === 501) {
        SetLoginErrorMssg("Internal Server Error");
        setUserId("");
        setpassword("");
      } else {
        SetLoginErrorMssg("Please check your UserId and Password!");
        setUserId("");
        setpassword("");
      }
    } catch (err) {
      SetLoginErrorMssg(err.message);
    } finally {
      setLoading(false);
    }
  }

  // useEffect(() => {
  //   document.title = "TECHLABS INTRANET SOLUTION";
  // }, []);

  const upcomingFestival = async () => {
    const result = await fetchWrapper(
      "GET",
      `${localStorage.getItem("BaseUrl")}/KnowledgeShare/UpcomingEvent`
    );
    if (result.resCode === 200) {
      setUpcomingFestival(result.resData);
    }
  };

  const handleForgetPassword = () => {
    setActiveModalId(true);
  };

  const handleSendMail = async () => {
    setSendmailbutton(<LoadingOutlined />);
    const result = await fetchWrapper(
      "GET",
      `${localStorage.getItem(
        "BaseUrl",
      )}/Authentication/ForgetPasswordMail?EmpId=${OfficialMail}&name="web"`,
    );
    if (result.resCode === 200) {
      msgSuccess("Mail sent", messageApi);
      setSendmailbutton("Send Mail");
      setActiveModalId(false);
    } else if (result.resCode === 201) {
      msgError("Employee ID not Exist", messageApi);
      setSendmailbutton("Send Mail");
    } else {
      msgError("An error occurred. The email could not be sent.", messageApi);
      setSendmailbutton("Send Mail");
      setActiveModalId(false);
    }
  };

  return (
    <>
      {contextHolder}
      <div className="container-fluid logon">
        <div className="row justify-content-center align-items-center w-100 flex-grow-1">
          <div className="col-12 col-md-6 type-writer-box">
            {upcomingFestivals && upcomingFestivals.length > 0 && (
              <div className="d-flex justify-content-center align-items-center mt-3">
                <img
                  src={`data:image/gif;base64,${upcomingFestivals[currentFestivalIndex].gifBase64}`}
                  alt={upcomingFestivals[currentFestivalIndex].name}
                  style={{
                    maxWidth: "200px",
                    height: "auto",
                    display: "block",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
            <TypewriterComponent
              options={{
                strings: [
                  "Human Resources",
                  "Knowledge Sharing",
                  "Sales Net",
                  "Data Review",
                ],
                autoStart: true,
                loop: true,
                wrapperClassName: "typewriting",
                cursorClassName: "typewriting-cursor",
                delay: 40,
                deleteSpeed: 40,
              }}
            />
          </div>

          {/* Login box */}
          <div className="col-12 col-md-6 d-flex justify-content-center">
            <div
              className="login-box ibox bg-boxshadow"
              style={{ background: "#1839850d" }}
            >
              <div className="d-flex justify-content-center align-items-center">
                <img
                  src={logo2}
                  alt="logo"
                  style={{ width: "200px", margin: "0px 0px 25px 0px" }}
                />
              </div>

              <div className="ibox-title basic-form mb-30 bg-transparent text-center">
                <h5 style={{ fontSize: "18px", lineHeight: "27px" }}>
                  Sign In Here
                </h5>
              </div>

              <hr style={{ marginBottom: "25px" }} />

              <div className="ibox-content">
                <form onSubmit={handleSubmit}>
                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Login Id</label>
                    <div className="col-lg-9">
                      <input
                        type="text"
                        value={UserId}
                        onChange={(e) => setUserId(e.target.value)}
                        placeholder="UserId"
                        className="form-field w-100"
                        required
                      />
                    </div>
                  </div>

                  <div className="form-group row">
                    <label className="col-lg-3 col-form-label">Password</label>
                    <div className="col-lg-9">
                      <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setpassword(e.target.value)}
                        className="form-field w-100"
                        required
                      />
                    </div>
                  </div>

                  {loginErrorMssg && (
                    <p className="text-danger col-form-label">
                      {loginErrorMssg}
                    </p>
                  )}

                  {loading && !loginErrorMssg && (
                    <p className="text-primary col-form-label">Loading...</p>
                  )}

                  <div className="form-group d-flex justify-content-between align-items-center mt-3">
                    <Button onClick={handleForgetPassword}>
                      Forgot Password
                    </Button>
                    <Button
                      htmlType="submit"
                      style={{
                        color: "white",
                        fontSize: "13px",
                        padding: "0.5rem 2.5rem",
                        background: "#C0392B",
                      }}
                    >
                      Sign in
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Forget password modal */}
        <AntdModal
          modalTitleHeading={
            <>
              <UnlockOutlined
                size="large"
                style={{ marginRight: 6, fontSize: "24px" }}
              />
              Forget Password ?
            </>
          }
          isVisible={activeModalId}
          onConfirm={handleSendMail}
          onClose={() => setActiveModalId(false)}
          primaryBtnText={sendMailbutton}
          secondaryBtnText="Cancel"
        >
          <form className="container-fluid">
            <div className="d-flex modal-body w-100">
              <div className="container-fluid">
                <div className="row">
                  <p>
                    A password reset link will be sent to your registered email
                    address.
                  </p>
                  <div className="col-12 mt-2">
                    <ModalinputNumberFormField
                      className="w-100"
                      labelFor="enterEmmid"
                      labelText="Enter Employee ID"
                      onChange={(value) => setOfficialMail(value)}
                      value={OfficialMail}
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </AntdModal>
      </div>
    </>
  );
}
